import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Area, TipoArea } from '../../models/area';
import { Contato } from '../../models/contato';
import { Empresa } from '../../models/empresa';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { Subscription } from 'rxjs';
import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { AdicionarContatoPage } from '../../pages/adicionar-contato/adicionar-contato';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';

@Component({
  selector: 'lista-conversas',
  templateUrl: 'lista-conversas.html'
})
export class ListaConversasComponent {
  @Output() areaSelecionada: EventEmitter<Area>;
  @Output() contatoSelecionado: EventEmitter<Contato>;
  public conversaSelecionada: any;
  public setores: Area[];
  public centrosDeCusto: Area[];
  public contatos: Contato[];
  private subscriptions: Subscription;
  public empresa: any;

  constructor(private changeDetectorRef: ChangeDetectorRef, 
    private mensagemProvider: MensagemProvider, 
    private areaLocalProvider: AreaLocalProvider, 
    private contatoLocalProvider: ContatoLocalProvider,
    private empresaLocalProvider: EmpresaLocalProvider) {
    this.areaSelecionada = new EventEmitter<Area>();
    this.contatoSelecionado = new EventEmitter<Contato>();
    this.subscriptions = new Subscription();
  } 

  ngOnInit() {
    const subEmpresa = this.empresaLocalProvider.$empresa.subscribe(
      (empresa) => {
        this.empresa = empresa;
      }
    )
    const subContatos = this.contatoLocalProvider.$contatos.subscribe(
      (contatos: Contato[]) => {
        this.atualizarContatos(contatos);
      }
    );
    const subAreas = this.areaLocalProvider.$areas.subscribe(
      (areas: Area[]) => {
        this.atualizarAreas(areas);
      }
    );
    this.subscriptions.add(subEmpresa);
    this.subscriptions.add(subContatos);
    this.subscriptions.add(subAreas);
    this.selecionarPrimeiroItem();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private selecionarPrimeiroItem() {
    if (this.setores && this.setores.length > 0) {
      this.conversaSelecionada = this.setores[0];
      this.selecionarArea(this.conversaSelecionada);
    } else if (this.centrosDeCusto && this.centrosDeCusto.length > 0) {
      this.conversaSelecionada = this.centrosDeCusto[0];
      this.selecionarArea(this.conversaSelecionada);
    } else if (this.contatos && this.contatos.length > 0) {
      this.conversaSelecionada = this.contatos[0];
      this.selecionarContato(this.conversaSelecionada);
    }
  }

  public selecionarArea(area: Area): void {
    this.conversaSelecionada = area;
    this.areaSelecionada.emit(area);
  }

  public selecionarContato(contato: Contato): void {
    this.conversaSelecionada = contato;
    this.contatoSelecionado.emit(contato);
  }

  private atualizarAreas(areas: Area[]): void {
    if (!areas) {
      return
    }
    const setores = [];
    const centrosDeCusto = [];
    for (const area of areas) {
      if (area.tipo == TipoArea.SETOR) {
        setores.push(area);
      } else {
        centrosDeCusto.push(area);
      }
    } 
    this.atualizarSetores(setores);
    this.atualizarCentrosDeCusto(centrosDeCusto);
  }

  private atualizarSetores(setores: Area[]): void {
    if (!setores) {
      return;
    }
    this.setores = this.ordenenarListaPorDataDaUltimaMensagem(setores);
    this.detectChanges();
  }

  private atualizarCentrosDeCusto(centrosDeCusto: Area[]): void {
    if (!centrosDeCusto) {
      return;
    }
    this.centrosDeCusto = this.ordenenarListaPorDataDaUltimaMensagem(centrosDeCusto);
    this.detectChanges();
  }

  private atualizarContatos(contatos: Contato[]): void {
    if (!contatos) {
      return;
    }
    this.contatos = this.ordenenarListaPorDataDaUltimaMensagem(contatos);
    this.detectChanges();
  }

  private ordenenarListaPorDataDaUltimaMensagem<T>(lista: T[]): T[] {
    return lista.sort((a: any, b: any) => {
      let timeA = 0;
      let timeB = 0;
      if (a.mensagens) {
        timeA = this.mensagemProvider.getDateMensagem(a.mensagens[a.mensagens.length - 1]).getTime();
      }
      if (b.mensagens) {
        timeB = this.mensagemProvider.getDateMensagem(b.mensagens[b.mensagens.length - 1]).getTime();
      }
      return timeB - timeA
    });
  }

  private detectChanges(): void {
    try {
      this.changeDetectorRef.detectChanges();
    } catch(err) {}
  }
}



// WEBPACK FOOTER //
// ./src/components/lista-conversas/lista-conversas.ts